var React = require('react');

function TriangleHeader (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M156.802 172.374L250.345 37.3815L293.449 292.428L156.802 172.374Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M16.713 146.864L250.578 37.4238L157.099 172.2L16.713 146.864Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M16.7148 146.864L157.002 172.183L293.446 292.428L16.7148 146.864Z","fill":"#5915C7","key":2})]);
}

TriangleHeader.defaultProps = {"width":"337","height":"293","viewBox":"0 0 337 293","fill":"none"};

module.exports = TriangleHeader;

TriangleHeader.default = TriangleHeader;
